


























import { computed, defineComponent, PropType, ref } from '@nuxtjs/composition-api'
import useI18n from '@/composables/use-i18n'
import PricedCar from '@/classes/PricedCar'

export default defineComponent({
  props: {
    car: {
      type: Object as PropType<PricedCar>,
      required: true,
    },
  },
  setup (props) {
    const i18n = useI18n()
    const showModal = ref(false)

    // Extract insurance names from car object
    const insurances = computed(() => {
      return props.car.insurances?.map(insurance => insurance.name) || []
    })

    // Generate insurance title with count
    const insuranceTitle = computed(() => {
      const count = insurances.value.length
      return i18n.tc('carCard.badge.insurance', count, [count])
    })

    // Handle modal open
    const openModal = () => {
      showModal.value = true
    }

    return {
      showModal,
      insurances,
      insuranceTitle,
      openModal,
    }
  },
})
